/**
 * /tenants/$slug/agents/virtual-keys — the virtual-key roster (AI Agents → Agent governance).
 *
 * Thin shim: validate search, prefetch, mount the feature page. The optional `agent` search param
 * is the URL-as-source-of-truth for the roster filter, so a filtered view is a shareable link.
 */

import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { fetchVirtualKeys } from "@/features/agent-virtual-keys/queries";
import { VirtualKeysPage } from "@/features/agent-virtual-keys/pages/virtual-keys-page";

const searchSchema = z.object({
  agent: z.string().optional(),
});

export const Route = createFileRoute("/_authed/tenants/$slug/agents/virtual-keys")({
  validateSearch: searchSchema,
  loaderDeps: ({ search }) => ({ agent: search.agent }),
  loader: ({ context, deps }) =>
    context.queryClient.ensureQueryData({
      queryKey: ["agents", "virtual-keys", context.tenant.id, deps.agent ?? "all"],
      queryFn: () => fetchVirtualKeys(context.tenant.id, deps.agent),
    }),
  component: RouteComponent,
});

function RouteComponent() {
  const { tenant } = Route.useRouteContext();
  const { slug } = Route.useParams();
  const { agent } = Route.useSearch();
  return <VirtualKeysPage tenantID={tenant.id} tenantSlug={slug} agentID={agent} />;
}
